import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { Vue } from 'vue-class-component';
var GridItem = /*#__PURE__*/function (_Vue) {
  function GridItem() {
    _classCallCheck(this, GridItem);
    return _callSuper(this, GridItem, arguments);
  }
  _inherits(GridItem, _Vue);
  return _createClass(GridItem);
}(Vue);
export { GridItem as default };